import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  TrialEndedModalContinueUsing,
  TrialEndedModalCurrentProduct,
  TrialEndedModalStyled,
  TrialEndedModalSubtitle,
} from './TrialEndedModal.styled'
import {
  Modal,
  Button,
  ModalControlsStyled,
  useFrontEndEventTrackingService,
} from '@clickcease/cc-client-components-lib'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'

interface TrialEndedModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
}

export const TrialEndedModal = ({ isOpen, onOpenChange }: TrialEndedModalProps) => {
  const { t } = useTranslation('accountSettings')
  const navigate = useNavigate()
  const { setModalToShow } = useAppStore()
  const { track } = useFrontEndEventTrackingService()
  const { data: planDetails } = useGetPlansDetails()

  const closeModal = () => {
    track(['segment'], `Trial ended modal closed`, {})
    onOpenChange(false)
  }

  const goToBilling = () => {
    track(['segment'], `Trial ended modal stay protected clicked`, {})
    navigate('/account-settings', {
      state: { openPaymentMethod: true, origin: 'trialEndedModal' },
    })
    setModalToShow('')
  }

  const product =
    (planDetails?.plans?.length || 0) > 1
      ? t('trial_ended_modal.both')
      : t(`trial_ended_modal.${planDetails?.plans?.[0].product || ''}`)

  return (
    <Modal
      title={t('trial_ended_modal.title')}
      isOpen={isOpen}
      onOpenChange={closeModal}
      onCloseClick={() => {}}
    >
      <TrialEndedModalStyled>
        <TrialEndedModalSubtitle>
          {t('trial_ended_modal.subtitle')}
          <TrialEndedModalCurrentProduct>{t(product)}</TrialEndedModalCurrentProduct>
          <TrialEndedModalContinueUsing>
            {t('trial_ended_modal.to_continue_using')}
          </TrialEndedModalContinueUsing>
        </TrialEndedModalSubtitle>
        <ModalControlsStyled>
          <Button text={t('trial_ended_modal.apply')} onClick={goToBilling} />
        </ModalControlsStyled>
      </TrialEndedModalStyled>
    </Modal>
  )
}
